module.exports = __webpack_public_path__ + "assets/img/27_1432_big.009a4f42.jpg";